/**
 * 再ログインダイアログ（03 3.4.5・5.4）：延長できなかったときに画面の上に出す。画面の入力はそのまま残る（要件書 NFR-08）。
 * 利用者のメールアドレス（表示のみ）に確認コードを送り（API-AUTH-01）、コードを受けて API-AUTH-02 を呼ぶ。
 */
import { Alert, Box, Button, Dialog, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import type { AuthVerifyResponse } from '@pcrm/shared';
import { errorText, t } from '@pcrm/shared';
import { useCodeLogin } from '../hooks/useCodeLogin';
import { CodeLoginFields } from './CodeLoginFields';

export interface ReloginDialogProps {
  is_open: boolean;
  email: string;
  onLoggedIn: (result: AuthVerifyResponse) => void;
}

export function ReloginDialog(props: ReloginDialogProps) {
  const { state, sendCode, verifyCode } = useCodeLogin({ initial_email: props.email, onLoggedIn: props.onLoggedIn });
  return (
    <Dialog open={props.is_open} maxWidth="xs" fullWidth aria-labelledby="pcrm-relogin-title">
      <DialogTitle id="pcrm-relogin-title">もう一度ログインしてください</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 1 }}>
          {errorText('AUTH_004')}
        </Typography>
        <Alert severity="info" sx={{ mb: 2 }}>
          {t('FE-MSG-I-007')}
        </Alert>
        {state.notice && (
          <Alert
            severity={state.notice.severity}
            sx={{ mb: 2 }}
            role={state.notice.severity === 'error' ? 'alert' : 'status'}
          >
            {state.notice.text}
          </Alert>
        )}
        <TextField label="メールアドレス" value={props.email} disabled sx={{ mb: 2 }} />
        {state.step === 'email' ? (
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button variant="contained" disabled={state.is_sending} onClick={() => void sendCode(props.email)}>
              コードを送信
            </Button>
          </Box>
        ) : (
          <CodeLoginFields
            submit_label="ログインして続ける"
            code_error={state.code_error}
            is_verifying={state.is_verifying}
            is_sending={state.is_sending}
            resend_wait_seconds={state.resend_wait_seconds}
            onVerify={(code) => void verifyCode(code)}
            onResend={() => void sendCode(props.email, true)}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
